import { createSlice } from '@reduxjs/toolkit';

import { InitialState } from './models';
import { ProfessionalActions } from './actions';

const defaultState = {
  stripeAccountId: '',
  subscriptionId: '',
  clientSecret: '',
  subscription: null,
  paymentMethods: [],
};

const initialState: InitialState = defaultState;

const professionalSlice = createSlice({
  name: 'professionalSlice',
  initialState,
  reducers: { resetProfessionalProfile: () => defaultState },
  extraReducers(builder) {
    //subscription payment
    builder.addCase(
      ProfessionalActions.subscriptionPayment.fulfilled,
      (state, action) => {
        state.stripeAccountId = action.payload.stripeAccountId;
        state.subscriptionId = action.payload.subscriptionId;
        state.clientSecret = action.payload.clientSecret;
      },
    );
    //fetch professional subscription by id
    builder.addCase(
      ProfessionalActions.fetchProfessionalSubscriptionById.fulfilled,
      (state, action) => {
        state.subscription = action.payload;
      },
    );
    //fetch subscription payment methods
    builder.addCase(
      ProfessionalActions.fetchSubscriptionPaymentMethods.fulfilled,
      (state, action) => {
        state.paymentMethods = action.payload;
      },
    );
    builder.addCase(
      ProfessionalActions.fetchCompanyPaymentMethods.fulfilled,
      (state, action) => {
        state.paymentMethods = action.payload;
      },
    );
  },
});

export const ProfessionalAction = professionalSlice.actions;

export default professionalSlice.reducer;
